import CommonOTSheet from "../../components/common/OTSheet/CommonOTSheet"

const ApprovedSheet = () => {
  return (
    <div className="bg-white">
      <CommonOTSheet view_by_status={1} sheet_name="Approval" />
    </div>
  );
}
export default ApprovedSheet